import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import './radioButton.styles.scss';

export interface CustomRadioProps {
	name: string;
	value?: string;
	activeValue?: string | number;
	label?: string;
	id?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	wrapperClass?: string;
	style?: CSSProperties;
	required?: boolean;
	hideIcon?: boolean;
	checked?: boolean;
	formField?: boolean;
	readOnly?: boolean;
	disabled?: boolean;
}

export const CustomRadio = React.forwardRef<
	HTMLInputElement,
	React.PropsWithChildren<CustomRadioProps>
>(
	(
		{
			wrapperClass = '',
			name,
			id,
			children,
			value,
			activeValue,
			onChange,
			style,
			required,
			hideIcon,
			label,
			checked,
			formField,
			readOnly,
			disabled,
		},
		ref,
	) => {
		const isChecked = checked || `${activeValue}` === value;

		return (
			<label
				htmlFor={id}
				className={classNames('radio', wrapperClass, {
					checked: isChecked,
					disabled,
				})}
				style={style}
			>
				<input
					id={id || value}
					name={name}
					value={value}
					required={required}
					ref={ref}
					onChange={onChange}
					type="radio"
					className="radio__input"
					checked={formField ? undefined : isChecked}
					hidden
					disabled={disabled}
				/>
				{hideIcon || <div className="radio__icon" />}
				{label && <span className="radio__label">{label}</span>}
				{children}
			</label>
		);
	},
);
